import "./LocationsTabUI.css";

import { FC, useEffect, useMemo, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { IAppState } from "../../../../../store/reducers";
import { InputText } from "primereact/inputtext";
import { LocationTabToolbar } from "./LocationsTabToolbar/LocationsTabToolbar";
import { LocationsService } from "../../../../../services/LocationsService";
import { locationsInitialData } from "../../../EmployeeAssignemnt";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import { sortDDLByLabel } from "../../../../../common/Common";

// import { Button } from "primereact/button";

// import { Toolbar } from "primereact/toolbar";











let emptyLocation = {
	id: null,
	locations: "",
	fromDate: null,
	toDate: null,
	notes: "",
	rowWithRandomId: true
};

const useGetLocationsDDL = (clientId: string) =>
	useQuery({
		queryKey: ["locations-ddl", clientId],
		queryFn: () => {
			return LocationsService.getGetLocationsDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

interface ILocationsTabsPanel {
	locationsUpdatedData: (data: any) => void;
	locationsDataItems: any;
	TabTableheaderColumns: any;
	selectedEmployeeLabel: string;
	onRowDeleteClicked: (data: any) => void;
}
export const LocationsTabsPanel: FC<ILocationsTabsPanel> = ({
	locationsUpdatedData,
	locationsDataItems,
	TabTableheaderColumns,
	selectedEmployeeLabel,
	onRowDeleteClicked,
}) => {
	const theme = useTheme();
	const [locations, setLocations] = useState<any>(locationsDataItems);
	const [selectedLocations, setSelectedLocations] = useState<any>(null);
	const [location, setLocation] = useState(emptyLocation);
	const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);

	const clientId = useSelector((state: IAppState) => state.client.id);

	const { data: locationsDDL, isLoading: isLoading } =
		useGetLocationsDDL(clientId);
	const locationsDDLItems = useMemo(() => {
		if (locationsDDL && Array.isArray(locationsDDL)) {
			let resources: any[] = sortDDLByLabel(locationsDDL).map((resourceItem: any) => ({
				id: resourceItem.id,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			resources.unshift({
				label: "--",
				value: null,
			});
			return resources;
		}
		return [
			{
				label: "--",
				value: null,
			},
		];
	}, [locationsDDL]);

	useEffect(() => {
		locationsUpdatedData(locations);
	}, [locations]);

	useEffect(() => {

		setLocations(locationsDataItems);
	}, [locationsDataItems]);

	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < locations.length; i++) {
			if (locations[i].id === id) {
				index = i;
				break;
			}
		}

		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		return id;
	};

	// const openNew = () => {
	// 	// alert("new")

	// 	let _locations = [...locations];
	// 	let _location: any = { ...location };

	// 	if (location.id) {
	// 		const index = findIndexById(location.id);

	// 		_locations[index] = _location;
	// 	} else {
	// 		_location.id = createId();
	// 		_locations.push(_location);
	// 	}

	// 	setLocations(_locations);
	// 	setLocation(emptyLocation);
	// };

	const openNew = () => {
		// if (employeeStatus && employeeStatus.length >= 4) return null;
		let _locationsSetupPanelData = [...locations];
		let _locationSetupPanelNewRow: any = { ...location };

		if (location.id) {
			const rowIndex = findIndexById(location.id);
			_locationsSetupPanelData[rowIndex] = _locationSetupPanelNewRow;

		} else {
			const newRowId = createId();
			_locationSetupPanelNewRow.id = newRowId;
			_locationsSetupPanelData.push(_locationSetupPanelNewRow);
			setLastAddedRowId(newRowId && newRowId);

		}
		setLocations(_locationsSetupPanelData);
		setLocation(emptyLocation);
	};


	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		// const updatedData = [...locations];
		// updatedData[rowIndex][event.field] = field;
		// setLocations(updatedData);
		setLocations((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});

	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "fromDate") {
			if (
				rowData.locations !== "" &&
				rowData.locations !== undefined &&
				rowData.locations !== null
			) {
				if (rowData.fromDate === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.fromDate === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else if (field.field === "locations") {
			if (
				rowData.fromDate !== "" &&
				rowData.fromDate !== undefined &&
				rowData.fromDate !== null
			) {
				if (rowData.locations === null) {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				} else if (rowData.locations === "") {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				}
			} else {
				return "p-component p-filled input-dropdown-fields .p-dropdown";
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "label") {
			return (
				<span>
					<b>
						Select Location 
					</b>
				</span>
			);
		} else if (x.field === "locations") {
			return (
				<Dropdown
					options={locationsDDLItems}
					value={rowData.locations}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="--"
					className={renderErrorClass(x, row.rowIndex, rowData)}
					optionLabel="label"
					optionValue="value"
				/>
			);
		} else if (x.field === "fromDate") {
			return (
				<Calendar
					id="fromDate"
					value={rowData[x.field]}
					showIcon
					// className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
				/>
			);
		} else if (x.field === "toDate") {
			return (
				<Calendar
					id="toDate"
					value={rowData[x.field]}
					showIcon
					className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
				/>
			);
		} else if (x.field === "notes") {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="Write notes here"
					className={"notesField p-component p-filled input-dropdown-fields"}
				/>
			);
		}
	};

	const onDeleteNewAddedRow = (rowId: any) => {
		setLocations((prev: any[]) => {
			const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

			if (rowDeleteBasedOnId.length > 1) {
				const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
				setLastAddedRowId(lastRowId);
			} else {
				setLastAddedRowId(null);
			}
			return rowDeleteBasedOnId;
		});
	}

	return (
		<>
			{locationsDDL ? (
				<div className="card">
					<LocationTabToolbar
						openNew={openNew}
						selectedEmployeeLabel={selectedEmployeeLabel}
					/>
					<DataTable
						value={locations}
						// key={JSON.stringify(locationsDDLItems)}
						dataKey="id"
						key={lastAddedRowId}
						showGridlines
						className="LocationsTab"
						editMode="cell"
						resizableColumns
						columnResizeMode="expand"
						scrollable
						// reorderableColumns
						filterDisplay="menu"
						scrollHeight="516px"
						loading={isLoading}
					>
						{TabTableheaderColumns.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									sortable={false}
									// resizeable={x.resizable}
									// dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={false}
									// exportable={x.disableExport}
									frozen={x.frozenColumn}
									columnKey={x.field}
									style={{
										width: x.minWidth,
										fontSize: "0.875rem",
									}}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}


						{/* <Column
							body={(rowData: any, row: any) => {
								const showIcon = rowData.id === lastAddedRowId;
								return showIcon ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent"
										rounded
										// onClickHandler={onDeleteNewAddedRow}
										onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
									/>
								) : null;
							}}
						/> */}

						<Column
							body={(rowData: any, row: any) => {
								const isLastRow = row.rowIndex === locations.length - 1;
								console.log("isLastRow", isLastRow)
								return isLastRow ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
										rounded
										onClickHandler={() => rowData.rowWithRandomId ? onDeleteNewAddedRow(rowData.id) : onRowDeleteClicked(rowData)}
									/>
								) : null;
							}}
						/>
					</DataTable>
				</div>
			) : (
				<></>
			)}
		</>
	);
};
